<div class="modal-content" xmlns="http://www.w3.org/1999/html">
    <div class="modal-header">
        <h3>Fill out and send form to patient</h3>
        <div class="modal-close" aria-label="Close" (click)="closeModalEvent(false)">
            <img class="cross-close" src="/content/icons/Close-Black.svg">
        </div>
    </div>
    <app-error-message [errorMessage]="error"></app-error-message>
    <div class="modal-body">
        <div class="modal-body-content">
            <span class="main-section">
                <form [formGroup]="fg">
                    <div fxLayout="row">
                        <div class="card">
                            <div class="card-header header">
                                <div class="icon"><span><img src="/content/icons/end-user.svg"></span></div>
                                <div class="text">{{'End-user' | translate}}</div>
                            </div>
                            <div class="card-body body">
                                <table class="content-table">
                                    <tbody>
                                        <tr>
                                            <td class="label">
                                                {{'First name' | translate }}<span class="required">*</span>
                                            </td>
                                            <td class="value">
                                                <input formControlName="firstName" data-test="patient-first-name">
                                                <app-form-control-error-message [control]="fg.get('firstName')"
                                                                                labelKey="First name">
                                                </app-form-control-error-message>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="label">
                                                {{'Mobile phone' | translate }}<span class="required">*</span>
                                            </td>
                                            <td class="value">
                                                <div class="d-flex">
                                                    <div class="mr-auto" style="width: 35%;">
                                                        <app-input-country formControlName="mobilePhoneCountryCode"
                                                                           [withInput]="false"
                                                                           [showCode]="true"
                                                                           (change)="endUserMobilePhoneCountryChanged($event)"
                                                                           data-test="patient-mobile-country">
                                                        </app-input-country>
                                                    </div>
                                                    <div style="width: 20%; margin-top: 3px;">
                                                        <input formControlName="mobilePhonePrefix"
                                                               data-test="patient-mobile-prefix">
                                                    </div>
                                                    <div style="width: 45%; margin-top: 3px;">
                                                        <input formControlName="mobilePhone"
                                                               data-test="patient-mobile-number">
                                                        <app-form-control-error-message
                                                            [control]="fg.get('mobilePhone')"
                                                            labelKey="Mobile phone">
                                                        </app-form-control-error-message>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div fxLayout="row">
                        <div class="card">
                            <div class="card-header header">
                                <div class="icon fa-icon">
                                    <span>
                                        <fa-icon icon="file-contract"></fa-icon>
                                    </span>
                                </div>
                                <div class="text">{{'Reporter' | translate}}</div>
                            </div>
                            <div class="card-body body">
                                <table class="content-table">
                                    <tbody>
                                    <tr>
                                        <td class="label">
                                            {{'On behalf of' | translate}}<span class="required">*</span>
                                        </td>
                                        <td class="value">
                                            <ng-select class="custom"
                                                       [class.required-input]="!fg.controls.onBehalfOf.value"
                                                       [items]="supplierSelect"
                                                       bindValue="id"
                                                       bindLabel="name"
                                                       [clearable]="false"
                                                       formControlName="onBehalfOf"
                                                       data-test="reporter-on-behalf-of">
                                            </ng-select>
                                            <app-form-control-error-message [control]="fg.get('onBehalfOf')"
                                                                            labelKey="On behalf of">
                                            </app-form-control-error-message>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="label">
                                            {{'Your ref no' | translate }}
                                        </td>
                                        <td class="value">
                                            <input formControlName="refNo" data-test="reporter-ref-no-authenticated">
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </form>
            </span>
        </div>
    </div>

    <div class="modal-footer">
        <button mat-stroked-button type="button" class="secondary" (click)="closeModalEvent(false)">{{'Cancel' | translate}}</button>
        <button mat-stroked-button type="button" ngbAutofocus class="primary" (click)="submitForm()">
            {{'Send form for patient to fill out' | translate}}
        </button>
    </div>
</div>

